(function ($) {
    'use strict';

    var SELECTOR = '[data-admin-change-role-member]';
    var MEMBER_CHANGE_ROLE_API_URL = '/:lang/api/members/:id/change-role';

    var $html = $('html');
    var $body = $('body');

    var AdminChangeRoleMember = {};

    AdminChangeRoleMember.getMemberChangeRoleUrl = function (id) {
        return MEMBER_CHANGE_ROLE_API_URL
            .replace(':lang', $html.attr('lang'))
            .replace(':id', id)
        ;
    };

    AdminChangeRoleMember.onChange = function (event) {
        event.preventDefault();

        var $element = $(this),
            id = $element.data('admin-change-role-member'),
            apiUrl = AdminChangeRoleMember.getMemberChangeRoleUrl(id)
        ;

        $element.data('admin-change-role-member.state', 'loading');
        $element.addClass('is-loading');

        $.ajax(apiUrl, {
            method: 'POST',
            data: {
                'role' : $element.val()
            }
        })
            .done(function(data) {
                if (! data.ok) {
                    console.error('unknow error');
                    return;
                }

                $element.trigger('sync.admin-change-role-member');

                return true;
            })
            .fail(function () {
                $element.val($element.data('admin-change-role-member.role.original'));
            })
            .always(function () {
                $element.data('admin-change-role-member.state', null);
                $element.removeClass('is-loading');
            })
        ;
    };

    AdminChangeRoleMember.onSync = function () {
        var $element = $(this);

        $element.data('admin-change-role-member.role.original', $element.val());
    };

    $(document).ready(function () {
        $body.on('change.admin-change-role-member', SELECTOR, AdminChangeRoleMember.onChange);
        $body.on('sync.admin-change-role-member', SELECTOR, AdminChangeRoleMember.onSync);

        $body.find(SELECTOR).trigger('sync.admin-change-role-member');
    });

})(require('jquery'));
